export default {
  MINE_COURSEWARE: "mine-courseware",
  COURSEWARE_CENTER: "courseware-center",
  COURSEWARE_CENTER_CARTOON: "courseware-center-cartoon",
  MATERIAL_LIST: "material-list",
  MATERIAL_LIST_CARTOON: "material-list-cartoon",
};
